import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainNavbar from "./Components/Navbar";
import "./App.css";
import Home from "./Components/Home";
import AboutPage from "./Components/About";
import Footer from "./Components/Footer";
import ServiceDetailPage from "./Components/ServiceDetailPage";
import ProjectsPage from "./Components/ProjectsPage";
import ContactPage from "./Components/Contact";
import RealEstate from "./Components/RealEstate";
import ScrollToTop from "./Components/ScrollToTop";
import Company from "./Components/Company";

const App = () => {
  return (
    // <div className="overflow-hidden">
    <Router>
      <ScrollToTop />
      {/* <TopNavbar /> */}
      {/* <MainNavbar /> */}
      <Routes>
        <Route path="/" element={[<MainNavbar />, <Home />, <Footer />]} />
        <Route
          path="/about"
          element={[<MainNavbar />, <AboutPage />, <Footer />]}
        />
        <Route
          path="/company"
          element={[<MainNavbar />, <Company />, <Footer />]}
        />
        <Route
          path="/services/:service"
          element={[<MainNavbar />, <ServiceDetailPage />, <Footer />]}
        />
        <Route
          path="/projects"
          element={[<MainNavbar />, <ProjectsPage />, <Footer />]}
        />
        <Route
          path="/real-estate"
          element={[<MainNavbar />, <RealEstate />, <Footer />]}
        />
        <Route
          path="/contact"
          element={[<MainNavbar />, <ContactPage />, <Footer />]}
        />
      </Routes>
      {/* <Footer /> */}
    </Router>
    // </div>
  );
};

export default App;
